import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=4cab6b47&scoped=true"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=4cab6b47&prod&lang=scss&scoped=true"
import style1 from "./ContactsList.vue?vue&type=style&index=1&id=4cab6b47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab6b47",
  null
  
)

export default component.exports